
<template>
  <div class="head-item">
    <!-- <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"> -->
    <div v-if="list.length">
      <HeadItem style="margin-top:8px;" v-for="(item) in list" :key="item.id" :mes="item"></HeadItem>
      <!-- <p v-for="(item,index) in list" :key="index">{{item}}</p> -->
    </div>
    <div v-else class="f11">
      暂时还没有数据哦
    </div>
    <!-- </van-list> -->
  </div>
</template>

<script>
import HeadItem from "../components/HeadItem.vue";
import { getData } from "../Interface/http.js";
export default {
  name: "HeadItemTwo",
  data() {
    return {
      articleList: [],
      page: 1,
      category: "",
      loading: false,
      finished: false
    };
  },
  mounted() {
  },
  methods: {
    
  },
  
  props: ["list"],
  components: {
    HeadItem
  }
};
</script>

<style scoped>
.head-item {
  width: 100%;
  /* height:343px; */
  /* background: #fff; */
  margin-top: 6px;
  /* padding: 15px 46px 0px 33px; */
  box-sizing: border-box;
  border-radius: 5px;
}
.head-item-top {
  width: 100%;
  /* height: 44px; */
}
.phone {
  width: 41px;
  height: 41px;
}
.man-pic {
  width: 68px;
  height: 68px;
  margin-right: 11px;
  overflow: hidden;
  position: relative;
}
.man-pic img {
  width: auto !important;
  height: auto !important;
  max-width: 3rem;
  min-height: 34px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin:auto;
}
.head-item-bottom {
  height: 90px;
}
.main-mes {
  font-size: 24px;
  color: rgb(51, 51, 51);
  padding: 26px 0 24px 0;
}
.one-hour {
  color: rgb(143, 143, 143);
}
.main-pic {
  width: 58px;
  height: 58px;
}
.main-tag {
  margin-left: 7px;
}
.t128 {
  color: rgb(128, 128, 128);
  margin-top: 3px;
  width: 7rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tag-small div {
  width: 26px;
  height: 26px;
  margin-right: 6px;
}
</style>
